<template>

    <v-hero fluid>
        <div class="row">
            <div class="col-lg-6">
                <h1 class="mb-20">{{ title }}</h1>
                <h2 class="mb-30">{{ headline }}</h2>
                <v-button class="d-none d-lg-block" size="md" :loading="loading" @click.native="signup">Start 14-Day Free Trial</v-button>
            </div>
            <div class="col-lg-6">
                <div class="ss">
                    <div style="position: relative; padding-bottom: 56.25%; height: 0;">
                        <iframe :src="`https://www.loom.com/embed/${videoId}`" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen style="position: absolute; top: 0; left: 0; width: 100%; height: 100%;"></iframe>
                    </div>
                </div>
            </div>
        </div>
    </v-hero>

</template>

<style scoped lang="scss">

    .hero {
        h1, h2 {
            text-align: left;
        }
        .ss {
            background: $color-text;
            position: relative;
            width: 100%;
        }
    }

</style>

<script>

export default {

    props: {
        title: {
            type: String,
        },
        subtitle: {
            type: String,
        },
        image: {
            type: String,
        },
    },

    data() {
        return {
            appUrl: process.env.VUE_APP_APP_URL,
        }
    },

    computed: {

        headline() {
            switch (this.$route.name) {
            case 'feature-management':
                return this.$t('feature.management.headline');
            case 'feature-engagement':
                return this.$t('feature.engagement.headline');
            case 'feature-segmenting':
                return this.$t('feature.segmenting.headline');
            case 'feature-email':
                return this.$t('feature.email.headline');
            default:
                return '';
            }
        },

        videoId() {
            switch (this.$route.name) {
            case 'feature-management':
                return 'b3191aa7121d47db91491a62ae0d4de1';
            case 'feature-engagement':
                return 'abc5bd4314384284ac646e933c152c40';
            case 'feature-segmenting':
                return '85fa1198de5140359420b054f4afbfbd';
            case 'feature-email':
                return '63fb7c7abf454201a4a5e639acdccb33';
            default:
                return '';
            }
        },

    },

    methods: {

        signup() {
            window.location.href = `${this.appUrl}/signup`;
        },

    },

}

</script>